// DEPENDENCIES
import toString from 'lodash/toString';

export default function TimesCell({ value, placeholder }) {
  return toString(value).trim() ? value : placeholder;
}
